/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import SummaryCard from '../common/SummaryCard/SummaryCard';
import { useSignatureCards } from './useSignatureCards';

const useStyles = makeStyles(() => ({
  signatureCard: {
    minWidth: '31rem',
    maxWidth: '31rem',
  },
}));

/**
 * Signature cards component
 *
 * @param readOnly - read only
 * @param submission - used for mapEntityFields context creation
 * @returns {JSX.Element|null}
 * @constructor
 */
export default function SignatureCards({ readOnly, submission }) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const { signatures, getSignatureCardProps } = useSignatureCards(submission);

  return (
    <Grid container item spacing={2}>
      {signatures.map((signature, index) => (
        <Grid item xs="auto">
          <SummaryCard
            className={classes.signatureCard}
            readOnly={readOnly}
            anchorEl={anchorEl}
            actionType={null}
            {...getSignatureCardProps(signature, index)}
            handleClick={event => setAnchorEl(event.currentTarget)}
            handleClose={() => setAnchorEl(null)}
          />
        </Grid>
      ))}
    </Grid>
  );
}
